import { Endpoints } from '../../api';
import IUser from '../../components/entities/user';
import { addLog } from '../../redux/slices/log';
import { clearUser } from '../../redux/slices/user';
import { store } from '../../redux/store';

export async function authenticate(userInfo: IUser) {
    const url = `${Endpoints.authUrl}/auth/login`;
    return await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userInfo)
    })
        .then((res) => res.json())
        .catch(async (error) => {
            console.log('error auth:', JSON.stringify(error));
        });
}

export type AuthJsonResult = {
    httpOk: boolean;
    httpStatus: number;
    data: unknown;
};

export async function forgotPassword(userInfo: IUser): Promise<AuthJsonResult | null> {
    try {
        const res = await fetch(`${Endpoints.authUrl}/auth/ResetPassword`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(userInfo)
        });
        let data: unknown = null;
        try {
            data = await res.json();
        } catch {
            data = null;
        }
        return { httpOk: res.ok, httpStatus: res.status, data };
    } catch (error) {
        console.log(JSON.stringify(error));
        return null;
    }
}

export async function changePassword(userInfo: IUser, token: string): Promise<AuthJsonResult | null> {
    const hdr: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token !== undefined && token !== '') {
        hdr.Authorization = `Bearer ${token}`;
    }

    try {
        const res = await fetch(`${Endpoints.baseUrl}/account/changePassword`, {
            method: 'POST',
            headers: hdr,
            body: JSON.stringify(userInfo)
        });
        let data: unknown = null;
        try {
            data = await res.json();
        } catch {
            data = null;
        }
        return { httpOk: res.ok, httpStatus: res.status, data };
    } catch (error) {
        console.log(JSON.stringify(error));
        return null;
    }
}

export function registerUser(userInfo: any) {
    return fetch(`${Endpoints.authUrl}/auth/register`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(userInfo)
    })
        .then((res) => res.json())
        .catch(async (error) => {
            console.log('error:', JSON.stringify(error));
        });
}

export function deleteUser(email: any) {
    return fetch(`${Endpoints.authUrl}/auth/deleteUser`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: email
        })
    })
        .then((res) => res.json())
        .catch(async (error) => {
            console.log('error:', JSON.stringify(error));
        });
}

export function logout(accessToken: any, refreshToken: any) {
    return fetch(`${Endpoints.authUrl}/auth/revoke-token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ accessToken, refreshToken })
    }).then((res) => {
        store.dispatch(clearUser());
        store.dispatch(addLog('nativeSignUp'));

        res.json();
    });
}

export function getAccessUsingRefresh(refreshToken: string) {
    return fetch(`${Endpoints.authUrl}/auth/refresh-token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ refreshToken: refreshToken })
    }).then((res) => res.json());
}

export function getVerifiedKeys(keys: any) {
    if (keys.accessToken) {
        // if (!this.isTokenExpired(keys.accessToken)) {
        //   return keys;
        // } else if (keys.refreshToken) {
        //   const response = await this.getAccessUsingRefresh(keys.refreshToken);
        //   // await AsyncStorage.setItem("keys", JSON.stringify(response));
        //   return response;
        // }
    } else {
        return null;
    }
}

export function isTokenExpired(token: any) {
    //var decoded = jwt_decode<{ exp: number; iat: number }>(token);
    // return decoded.exp < Date.now() / 1000 ? true : false;
}

export function setCredentials(keys: any) {
    try {
        //await AsyncStorage.setItem("keys", JSON.stringify(keys));
    } catch (e) {
        console.log(JSON.stringify(JSON.stringify(e)));
    }
}

export function getCredentials() {
    try {
        // let credentials = await AsyncStorage.getItem("keys");
        const initial = '{ "refreshToken": "", "accessToken": "" }';
        // let cred = await this.getVerifiedKeys(
        //   JSON.parse(credentials == null ? initial : credentials)
        // );
        // if (credentials != null && cred != null) {
        //   return {
        //     accessToken: cred.accessToken,
        //     refreshToken: cred.refreshToken,
        //   };
        // } else {
        //   return null;
        // }
    } catch (e) {
        console.log(JSON.stringify(e));
    }

    return null;
}
